// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function toString(t) {
  return "[\\w-.%+-]+@[\\w-.%+-]+\\.[a-zA-Z]+$";
}

function make(t) {
  return new RegExp("[\\w-.%+-]+@[\\w-.%+-]+\\.[a-zA-Z]+$");
}

exports.toString = toString;
exports.make = make;
/* No side effect */
